<template>
  <div class="person-container">
    <el-form ref="form" :model="form" label-width="100px" :rules="rules">
      <div class="form-container">
        <div class="left-area">
          <div class="title">修改我的信息</div>
          <div class="content">
            <div class="image">
              <img
                :src="this.form.avatar ? this.form.avatar : avatarDefault"
                alt
              />
            </div>
            <div class="upload">
              <el-upload
                list-type="picture"
                class="upload-demo"
                :action="action"
                :data="data"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-progress="handleProgress"
                :before-upload="beforeUpload"
                :file-list="fileList"
                :accept="'.jpeg,.png,.jpg,.bmp'"
                ref="upload"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </div>
            <div class="message">
              支持jpg、png、jpeg、bmp<br />图片大小500K以内
            </div>
          </div>
        </div>
        <div class="right-area">
          <el-form-item label="昵称：" class="radio-front" prop="nickName">
            <el-input v-model="form.nickName" maxlength="25"></el-input>
          </el-form-item>
          <el-form-item label="性别：" class="radio-front">
            <el-radio-group v-model="form.gender">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
              <el-radio label="保密"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="职业：">
            <el-select
              @change="occupationChange"
              v-model="form.occupation"
              placeholder="请选择职业"
            >
              <el-option
                v-for="(item, i) in occupationOptions"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="常驻城市：">
            <!-- <el-select
              @change="provinceChange"
              v-model="form.provinceCode"
              placeholder="请选择省"
            >
              <el-option
                v-for="(item, i) in provinceOptions"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              @change="cityChange"
              v-model="form.cityCode"
              placeholder="请选择市"
            >
              <el-option
                v-for="(item, i) in cityOptions"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="form.permanentCity" placeholder="请选择区">
              <el-option
                v-for="(item, i) in areaOptions"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
            <el-cascader
              v-model="areaIdlist"
              :options="cityListCode"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="出生日期：">
            <el-date-picker
              v-model="form.birthday"
              type="date"
              value-format="yyyy-MM-dd hh:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="display:none" label="绑定手机：">
            <el-input v-model="form.phone" disabled></el-input>
          </el-form-item>
          <el-form-item label="绑定手机：">
            <el-input v-model="phone" disabled></el-input>
          </el-form-item>
          <el-form-item label="收货地址：">
            <el-input class="large-input" v-model="form.address"></el-input>
          </el-form-item>
          <!-- <el-form-item>
              <el-button type="primary" @click="onSubmit">立即创建</el-button>
              <el-button>取消</el-button>
          </el-form-item>-->
        </div>
        <div class="bottom-area">
          <div class="submit-btn" @click="save">保存</div>
          <div class="save-result" v-show="showSaveResult">
            {{ saveResult }}
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import avatarDefault from "@/assets/images/person/avatar-default.png";
import { mapState, mapActions, mapMutations } from "vuex";
import service from "../../axios/service/service";
import { ckeckNickNameUsed } from "../../axios/service/user.js";
import Global from "../../utils/Global";
import uploadUtils from "@/utils/uploadUtils";
export default {
  data() {
    let validateNickName = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        // 所有特殊字符的正则表达式
        let patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im;
        if (patrn.test(value)) {
          callback(new Error("特殊字符不可用，请重新输入"));
        } else {
          if (value === this.oldNickName) {
            callback();
          }
          ckeckNickNameUsed({
            oemId: this.apolloConfig.WORK.oemId,
            nickName: value
          }).then(json => {
            if (json.respCode === 100) {
              if (json.data.isNickNameExist) {
                //如果被注册了
                callback(new Error("很遗憾，昵称已被占用"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          });
        }
      }
    };
    return {
      fileBasePath: "", //文件上传成功后的地址
      oldNickName: "",
      timeOut: "", //3s后使保存结果消失使用
      showSaveResult: false,
      saveResult: "", //是否保存成功的提示信息
      oldForm: {}, // oldForm用于比较当保存时候form的内容有没有变化
      areaIdlist: [],
      action: "",
      data: {},
      fileList: [],
      travelDate: "",
      avatarDefault: avatarDefault,
      playWayList: [
        { code: "1", label: "自然风光" },
        { code: "2", label: "玩乐" },
        { code: "3", label: "名胜古迹" },
        { code: "4", label: "休闲游" },
        { code: "5", label: "人文探索" },
        { code: "6", label: "健康养生" }
      ],
      partnerList: [
        { code: "1", label: "独自一人" },
        { code: "2", label: "好友" },
        { code: "3", label: "亲子" },
        { code: "4", label: "情侣" },
        { code: "5", label: "闺蜜" },
        { code: "6", label: "同学" },
        { code: "7", label: "拼团" }
      ],
      occupationOptions: [
        { value: "1", label: "程序员" },
        { value: "2", label: "产品销售" },
        { value: "3", label: "客户服务" },
        { value: "4", label: "新媒体运营" },
        { value: "5", label: "公务员" },
        { value: "6", label: "法务顾问" },
        { value: "7", label: "教师" },
        { value: "8", label: "演员" },
        { value: "9", label: "导游/旅行达人" },
        { value: "10", label: "咨询/顾问" },
        { value: "11", label: "高级主管" },
        { value: "12", label: "平面设计" },
        { value: "13", label: "编辑" },
        { value: "14", label: "艺术家" },
        { value: "15", label: "摄影师" },
        { value: "16", label: "自由职业" },
        { value: "17", label: "其他" }
      ],
      playWay: "",
      partner: "",
      days: "",
      money: "",
      modalVisible: false,
      code: [],
      // provinceOptions: [],
      // cityOptions: [],
      // areaOptions: [],
      phone: "",
      form: {
        avatar: "",
        nickName: "",
        gender: "",
        occupation: "", //职业
        provinceCode: null,
        cityCode: null,
        permanentCity: null, //常驻城市
        birthday: "",
        phone: "",
        address: "",
        userId: this.$cookie.get("userInfo_userId")
      },
      rules: {
        nickName: [
          { required: false, message: "请输入活动名称", trigger: "blur" },
          { validator: validateNickName, trigger: ["blur", "change"] }
        ]
      }
    };
  },
  watch: {
    "form.phone"(newVal) {
      this.phone = newVal.substr(0, 4) + "****" + newVal.substr(8);
    },
    form(newVal) {},
    areaIdlist(value) {
      if (value) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.permanentCity = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.permanentCity = "";
      }
    },
    cityListCode: function(value) {
      // ;
      // this.code = value;
      // for (let i = 0; i < value.length; i++) {
      //   this.provinceOptions.push({
      //     label: value[i].label,
      //     value: value[i].value,
      //     children: value[i].children
      //   });
      // }
    },
    userdetailList(value) {
      // this.cityOptions = [];
      // this.areaOptions = [];
      // this.areaOptions = [];
      // this.form = value;
      this.form.address = value.address ? value.address : "";
      this.form.avatar = value.avatar ? value.avatar : "";
      this.form.birthday = value.birthday ? value.birthday : "";
      this.form.gender = value.gender ? value.gender : "";
      // 如果用户没有写昵称则将昵称设置为： 用户+用户id的形式
      this.form.nickName = value.nickName
        ? value.nickName
        : `用户${this.$cookie.get("userInfo_userId")}`;
      this.oldNickName = this.form.nickName;
      this.form.occupation = value.occupation ? value.occupation : "";
      this.form.phone = value.phone ? value.phone : "";
      if (this.provinceOptions !== []) {
        var code = value.permanentCity.substring(0, 6);
        if (code === "") {
          this.form.provinceCode = null;
          this.form.cityCode = null;
          this.form.permanentCity = null; //常驻城市
        } else {
          this.form.provinceCode = parseInt(code / 10000) * 10000;
          this.form.cityCode = parseInt(code / 100) * 100;
          this.form.permanentCity = Number(code); //常驻城市
          let beijing = 110000;
          let tianjin = 120000;
          let shanghai = 310000;
          let chongqing = 500000;
          let xianggang = 810000;
          let aomen = 820000;
          if (
            this.form.provinceCode == beijing ||
            this.form.provinceCode == tianjin ||
            this.form.provinceCode == shanghai ||
            this.form.provinceCode == chongqing ||
            this.form.provinceCode == xianggang ||
            this.form.provinceCode == aomen
          ) {
            //直辖市的省与市id一致
            this.form.cityCode = this.form.provinceCode;
          }
          /*
           * 省辖县
           */
          if (this.form.cityCode % 10000 == 9000) {
            //省辖县的市与县id一致
            this.form.cityCode = this.form.permanentCity;
            this.form.permanentCity = null;
          }
          if (this.form.cityCode === this.form.permanentCity) {
            this.form.permanentCity = parseInt(`${this.form.permanentCity}0`);
          }
          this.cityOptionsMutations({
            provinceCode: this.form.provinceCode,
            cityCode: this.form.cityCode,
            permanentCity: this.form.permanentCity
          });
          this.areaOptionsMutations({
            cityCode: this.form.cityCode,
            permanentCity: this.form.permanentCity
          });
        }
      } else {
        this.form.provinceCode = null;
        this.form.cityCode = null;
        this.form.permanentCity = null; //常驻城市
      }
      this.areaIdlist = [
        this.form.provinceCode,
        this.form.cityCode,
        this.form.permanentCity
      ];
      this.oldForm = { ...this.form };
    }
  },
  computed: {
    ...mapState("PersonalStore", [
      "userdetailList",
      "userModifyInformation",
      "cityListCode",
      "provinceOptions",
      "cityOptions",
      "areaOptions"
    ]),
    avatarUrl() {
      return this.form.avatar ? this.form.avatar : this.avatarDefault;
    }
  },
  created() {
    this.getCityListCode({ userId: this.$cookie.get("userInfo_userId") });
    // this.getUserdetail({ userId: this.$cookie.get("userInfo_userId") });
  },
  methods: {
    ...mapMutations("PersonalStore", [
      "cityOptionsMutations",
      "areaOptionsMutations"
    ]),
    ...mapActions("PersonalStore", [
      "getUserdetail",
      "getuserModify",
      "getCityListCode"
    ]),
    checkPlayWay(playWayNode) {
      this.playWay = playWayNode.code;
    },
    checkPartner(partnerNode) {
      this.partner = partnerNode.code;
    },
    validate() {
      return this.days && this.money;
    },
    editContinue() {
      if (!this.validate()) {
        this.modalVisible = true;
      } else {
      }
    },
    provinceChange(e) {
      this.form.cityCode = "";
      this.form.permanentCity = "";
      this.cityOptionsMutations({
        provinceCode: this.form.provinceCode,
        provinceOptions: this.provinceOptions,
        cityCode: this.form.cityCode
      });
    },
    cityChange(e) {
      this.form.permanentCity = "";
      this.areaOptionsMutations({
        cityCode: this.form.cityCode
      });
    },
    areaChange(e) {
      for (let i = 0; i < this.areaOptions.length; i++) {
        if (this.areaOptions[i].value === e) {
          this.form.permanentCity = this.areaOptions[i].label;
        }
      }
    },
    occupationChange(e) {
      this.form.occupation = e;
    },
    handleSuccess(response, file) {
      Global.messageSuc("上传成功");
      file.url = this.fileBasePath;
      this.form.avatar = file.raw.downloadUrl;
      // Global.messageErr("上传失败,请重新上传!");
    },
    handleProgress(event, file, fileLis) {},
    beforeUpload(file) {
      const isIMG =
        file.type === "image/jpg" ||
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png";

      if (!isIMG) {
        this.$message.error("支持上传JPG、JPEG、PNG、BMP格式，请重新上传");
        return false;
      }

      const isLt = file.size < 500 * 1024;

      if (!isLt) {
        this.$message.error("图片大小需限制在500K内，请重新上传");
        return false;
      }

      let param = {
        oemId: this.$cookie.get("userInfo_productId"),
        dirPath: `${this.$cookie.get("userInfo_productId")}${this.fileDirPath}`,
        fileName: file.name
      };
      return uploadUtils.prepareConfig(param, this, file);
    },
    save() {
      //判断用户信息是否作出修改
      if (this.hasUpdateUserInfo()) {
        this.$refs["form"].validate(valid => {
          if (valid) {
            let params = Object.assign({}, this.form);
            if (!params.birthday) {
              delete params.birthday;
            }
            params.vue = this;
            // 再次保存时清除计时
            clearTimeout(this.timeOut);
            this.getuserModify(params);
          } else {
            return false;
          }
        });
      } else {
        //如果没有作出更改则提示 "个人信息未做修改，无法保存"
        this.$message.error("个人信息未做修改，无法保存!");
      }
    },
    //比较判断用户信息是否作出修改
    hasUpdateUserInfo() {
      let compareKeys = Object.keys(this.form);
      //如果form和oldForm的每一字段都一样则返回true
      let compareResults = compareKeys.every(value => {
        return this.form[value] === this.oldForm[value];
      });
      return !compareResults; //如果比较结果是true,则表示没有作出修改，返回false
    }
  }
};
</script>
<style lang="less">
@import "~@/lesses/main/personal/person-info.less";
// Bug-ST #29954
.el-cascader-menu__list,
.el-select-dropdown__list {
  li:last-child {
    margin-bottom: 16px;
  }
}
</style>
